"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var Card_1 = __importDefault(require("@material-ui/core/Card"));

var CardActions_1 = __importDefault(require("@material-ui/core/CardActions"));

var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));

var CardMedia_1 = __importDefault(require("@material-ui/core/CardMedia"));

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var react_1 = __importDefault(require("react"));

var CollectionCard = function CollectionCard(_a) {
  var story = _a.story,
      urlFormatter = _a.urlFormatter;
  var description = story.description,
      id = story.id,
      image = story.image,
      label = story.label;
  var url = urlFormatter.replace('$id', id);
  return react_1.default.createElement(Card_1.default, null, image && react_1.default.createElement(CardMedia_1.default, {
    component: "img",
    image: image,
    title: label
  }), react_1.default.createElement(CardContent_1.default, null, react_1.default.createElement(Typography_1.default, {
    variant: "h5"
  }, label), react_1.default.createElement(Typography_1.default, {
    color: "secondary",
    variant: "overline"
  }, description)), react_1.default.createElement(CardActions_1.default, null, react_1.default.createElement(Grid_1.default, {
    container: true,
    justifyContent: "space-between"
  }, react_1.default.createElement(Grid_1.default, {
    item: true
  }, react_1.default.createElement(Button_1.default, {
    color: "primary",
    href: url,
    size: "small"
  }, "Learn More")), react_1.default.createElement(Grid_1.default, {
    item: true
  }, react_1.default.createElement(Typography_1.default, {
    color: "textSecondary",
    variant: "overline"
  }, id)))));
};

exports.default = CollectionCard;